











import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { FormatReference } from "../../../domain/format";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../system/mixins";
import PdfViewer from "../../system/viewers/PdfViewer.vue";
import FormatListSelector from "./FormatListSelector.vue";

@Component({
  components: {
    selector: FormatListSelector,
    viewer: PdfViewer
  }
})
export default class PreviewedFormatSelector extends Mixins(ModelEditableMixin, PdfStyleDrawableMixin) {
  data(): any {
    return {
      source: null as string,
    };
  }
  source: string;
  
  @Prop()
  formats: FormatReference[];

  mounted(): any {
    this.updateSource();
  }

  @Watch("editingSource")
  editingSourceUpdated(): void {
    this.updateSource();
  }

  get isFormatSelected(): boolean {
    return (this.editingSource !== null);
  }

  updateSource(): void {
    this.source = null;
    this.$nextTick(() => {
      if (this.editingSource && this.editingSource.previewSource) {
        this.source = this.editingSource.previewSource.source;
      }
    });
  }

  handleDoubleClicked(format: FormatReference): void {
    this.select(format);
  }

  @Emit()
  select(format: FormatReference): void {}
}
